<template>
  <v-card
    flat
    class="is-border-all border-light warehouse-info"
    :class="{ 'mt-5': $customLogoPath }">
    <v-card-text class="pa-8 is-relative straddle">
      <v-img
        width="65"
        height="65"
        class="circle mb-2 straddle__top"
        :src="$customLogoPath"
        v-if="$customLogoPath"></v-img>
      <div class="font-weight-bold mb-3 black--text mt-2">{{ $warehouseOrgName }}</div>
      <div class="secondary--text text-h5">{{ $warehouseName }}</div>
      <div class="my-1 d-flex align-center">
        <v-icon class="font-size-base mr-2">mdi-map-marker-outline</v-icon>
        <span class="font-size-small">
          <copy-content :content="$warehouseAddress" label="Click to copy warehouse address">
            {{ $warehouseAddress }}
          </copy-content>
        </span>
      </div>

      <v-tabs v-model="tab" grow id="warehouse-info-tabs" class="mt-10">
        <v-tab>
          <v-icon class="mr-2 font-size-base">mdi-text-box-outline</v-icon>
          Instructions
        </v-tab>
        <v-tab>
          <v-icon class="mr-2 font-size-base">mdi-email-outline</v-icon>
          Contact Info
        </v-tab>
        <v-tab>
          <v-icon class="mr-2 font-size-base">mdi-map</v-icon>
          Yard Map
        </v-tab>
        <v-tab>
          <v-icon class="mr-2 font-size-base">mdi-clock-time-four-outline</v-icon>
          Hours of Operation
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab" class="mt-8">
        <v-tab-item>
          <p v-html="$warehouseInstructions"></p>

          <div v-if="$warehousePpeRequirements?.length > 0">
            <h4 class="mb-5 mt-8">PPE and other requirements:</h4>
            <div
              style="width: 70px"
              v-for="ppeRequirement in $warehousePpeRequirements"
              :key="ppeRequirement"
              class="text-center float-left mr-6">
              <div>
                <img
                  height="50"
                  width="50"
                  :src="`/images/warehouse/${getPPERequirementIcon(ppeRequirement)}.png`" />
              </div>
              <p class="font-size-small" style="line-height: 20px">
                {{ ppeRequirement.toUpperCase() }}
              </p>
            </div>
          </div>
        </v-tab-item>
        <v-tab-item>
          <strong>Address</strong>
          <p>
            <copy-content :content="$warehouseAddress" label="Click to copy warehouse address">
              {{ $warehouseAddress }}
            </copy-content>
          </p>
          <strong>Phone</strong>
          <p>{{ $warehousePhone }}</p>

          <strong>Email</strong>
          <p>{{ $warehouseEmail }}</p>
        </v-tab-item>
        <v-tab-item>
          <div v-if="$consolidatedSettings.yardMap">
            <p>
              This image was provided by the warehouse. You can click on it to see the full image.
            </p>
            <a
              :href="getYardMapPath($consolidatedSettings)"
              rel="noopener noreferrer"
              target="_blank">
              <v-img
                width="600"
                height="400"
                max-width="100%"
                alt="Yard Map"
                cover
                :src="getYardMapPath($consolidatedSettings)">
              </v-img>
            </a>
          </div>
          <div v-else class="overlay-contents align-content-center text-center">
            <svg height="150" width="180">
              <g>
                <circle cx="90" cy="80" r="60" fill="#E5F1F7" />
                <foreignObject class="node" x="60" y="60" width="60" height="60">
                  <v-icon class="icon" x-large color="secondary lighten-4">mdi-map</v-icon>
                </foreignObject>
              </g>
            </svg>
            <h3 class="align-center">We couldn't find a yard map</h3>
            <p>It looks like this warehouse has not uploaded a map yet</p>
          </div>
        </v-tab-item>
        <v-tab-item>
          <hours-of-operation-list
            :schedule="$warehouseSchedule"
            :timezone="$warehouseTimezone"></hours-of-operation-list>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      tab: 0
    };
  },
  methods: {
    trackMixpanelViewEvent() {
      if (this.$warehouseId && this.$warehouseOrgId) {
        this.mixpanel.track(this.mixpanel.events.VIEW.WAREHOUSE.PAGE, {
          'Warehouse ID': this.$warehouseId,
          'Org ID': this.$warehouseOrgId
        });
      }
    },
    getPPERequirementIcon(ppeRequirement) {
      const index = Object.values(this.novaCore.PPERequirementsEnum).indexOf(ppeRequirement);
      return Object.keys(this.novaCore.PPERequirementsEnum)[index];
    },
    getYardMapPath(settings) {
      const map = settings.yardMap;
      return map
        ? this.novaCore.fileKeyToDownloadUrl(this.$store.getters['App/s3BaseUrl'], map)
        : null;
    }
  },
  async mounted() {
    this.trackMixpanelViewEvent();
  },
  watch: {
    $warehouseId() {
      this.trackMixpanelViewEvent();
    },
    $warehouseOrgId() {
      this.trackMixpanelViewEvent();
    }
  }
};
</script>
